(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
  var bar = document.querySelector('.sticky-atc');
  if (!bar) return;
  var sectionId = bar.dataset.sectionId;
  var section = document.querySelector('[data-section="' + sectionId + '"]');
  if (!section) return;
  var target = section.querySelector('.product-form__buttons');
  if (!target) target = section.querySelector('product-form');
  if (!target) return;
  var io = new IntersectionObserver(
    function (entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('sticky-atc--visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = bar.querySelector('button');
      if (btn) btn.setAttribute('tabindex', show ? '0' : '-1');
      document.body.classList.toggle('sticky-atc-active', show);
    },
    { threshold: 0, rootMargin: '0px 0px -60px 0px' }
  );
  io.observe(target);
})();
  } catch(e) { console.error(e); }
})();

})();
